module.exports = __webpack_public_path__ + "static/media/FOTO 3.5.00c6177e.jpg";